import { useState, useEffect } from 'react';
import { TopToolbar, useRecordContext, AutocompleteInput, ExportButton, Button, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';

import * as React from 'react';
import Box from '@mui/material/Box';
//import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const redirect = (handleClose, catalogId, basepath, id, data) => { 
    handleClose();
    return "catalogs/";
} ;

export default function CatalogProductModalCreate(props) {
    const record = useRecordContext();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Button
                onClick={() => { handleOpen() }}
                label="Lier un produit"
            >
                <IconAdd/>
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Ajouter un produit au catalogue
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Choisissez le produit à ajouter au catalogue
                </Typography>

                <Create resource="catalogProducts" record={{catalogId: record.id}} redirect={false}>
                    <SimpleForm>
                        <TextInput disabled source="catalogId" />
                        <ReferenceInput
                            source="productId"
                            reference="products"
                            perPage={10000}>
                            <AutocompleteInput optionText="full" />
                        </ReferenceInput>
                    </SimpleForm>
                </Create>

                </Box>
            </Modal>
        </div>
    );
}